/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');
    const PIN = feature.getSettingValue('PIN');
    const STATE = feature.getSettingValue('STATE');
    const PULL = feature.getSettingValue('PULL');
    const ACTIVE = feature.getSettingValue('ACTIVE');
    const dtsName = `${NAME}_gpio`;

    const peripherals = Peripherals.getPin(PIN, feature.project.device.id)?.peripherals;
    let peripheralPort = '0';
    let gpioNum: string | undefined = '0';
    if (peripherals) {
        peripheralPort = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
        gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].num;
    }

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        id: '#include <zephyr/drivers/gpio.h>',
        template: '#include <zephyr/drivers/gpio.h>',
    });

    blocks.push({
        location: 'APP_OVERLAY_DTS',
        blockType: BlockType.CODE,
        id: 'zephyr_app_overlay_buttons',
        template: `
buttons {
    compatible = "gpio-keys";
    /****zephyr_app_overlay_buttons****/
};`,
    });

    blocks.push({
        location: 'GLOBAL_DEFINES',
        blockType: BlockType.CODE,
        template: `
#if !DT_NODE_EXISTS(DT_NODELABEL(${dtsName}))
#error "Overlay for ${dtsName} node not properly defined."
#endif
        `,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
static const struct gpio_dt_spec ${dtsName} =
    GPIO_DT_SPEC_GET_OR(DT_NODELABEL(${dtsName}), gpios, {0});
        `,
    });

    const gpioFeature: any = feature;

    const dtsNode = `
    ${dtsName}:${dtsName} {
        gpios = <&${peripheralPort} ${gpioNum} ${gpioFeature.getFlags()}>;
    };
    `;


    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
gpio_pin_configure_dt(&${dtsName}, GPIO_INPUT);

if (gpio_pin_interrupt_configure_dt(&${dtsName}, GPIO_INT_EDGE_BOTH) != 0) {
    printk("failed to configure interrupt on %s pin %d\\n", ${dtsName}.port->name, ${dtsName}.pin);
    return 0;
}
gpio_init_callback(&${dtsName}_cb_data, ${dtsName}_triggered, BIT(${dtsName}.pin));
gpio_add_callback(${dtsName}.port, &${dtsName}_cb_data);
    `,
    });

    blocks.push({
        location: 'zephyr_app_overlay_buttons',
        blockType: BlockType.CODE,
        template: dtsNode,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `


void ${dtsName}_pressed_handler(struct k_work *work) {
    /****button_${NAME}_pressed****/
}

void ${dtsName}_released_handler(struct k_work *work) {
    /****button_${NAME}_released****/
}

void ${dtsName}_triggered(const struct device *dev, struct gpio_callback *cb, uint32_t pins) {
    int val = gpio_pin_get_dt(&${dtsName});
    //isr
    if (val == ${ACTIVE}) {
        if (k_work_busy_get(&${dtsName}_released_work) == 0) {
            k_work_submit(&${dtsName}_released_work);
        }
    } else {
        if (k_work_busy_get(&${dtsName}_pressed_work) == 0) {
            k_work_submit(&${dtsName}_pressed_work);
        }
    }
    var_${NAME}_set(val);
}`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
static struct gpio_callback ${dtsName}_cb_data;
struct k_work ${dtsName}_pressed_work;
struct k_work ${dtsName}_released_work;
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
k_work_init(&${dtsName}_pressed_work, ${dtsName}_pressed_handler);
k_work_init(&${dtsName}_released_work, ${dtsName}_released_handler);`,
    });

    blocks.push({
        location: `var_${NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${NAME}_update_completed(gpio_pin_get_dt(&${dtsName}));`,
    });

    return blocks;
};
